module.exports = __webpack_public_path__ + "images/speed-five-default.d7124e00c3edafe02adf618cb7566865.png";